import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  computed,
  input,
} from '@angular/core';

import { RouteScrollMode } from '../../../../layout/scroll-ownership/route-scroll-mode.models';
import {
  createMeasuredElementHeightTracker,
  registerRouteShellScrollMode,
} from '../layout-shell-runtime/layout-shell-runtime.util';

export type FlowPageLayoutContentScrollOwner = 'shell' | 'nested';

@Component({
  selector: 'app-flow-page-layout',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './flow-page-layout.component.html',
  styleUrl: './flow-page-layout.component.scss',
  host: {
    '[attr.data-scroll-mode]': 'scrollMode()',
    '[attr.data-content-scroll-owner]': 'contentScrollOwner()',
  },
})
export class FlowPageLayoutComponent {
  private readonly headerHeightTracker = createMeasuredElementHeightTracker();
  readonly scrollMode = input<RouteScrollMode>('app-shell');
  readonly contentScrollOwner = input<FlowPageLayoutContentScrollOwner>('nested');
  readonly measuredHeaderHeight = this.headerHeightTracker.height;
  readonly actionsTop = computed(() => this.measuredHeaderHeight());

  constructor() {
    registerRouteShellScrollMode(this.scrollMode);
  }

  @ViewChild('headerHost', { read: ElementRef })
  set headerHost(elementRef: ElementRef<HTMLElement> | undefined) {
    this.headerHeightTracker.observe(elementRef);
  }
}
